import * as React from 'react';

import ConsumerLoggedOutHomePageHeader from 'bundles/composable-page-header-consumer/header-renderers/ConsumerLoggedOutHomePageHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';
import FrontPageCmsContent from 'bundles/front-page/components/FrontPageCmsContent';
import { FrontPageDataProvider } from 'bundles/front-page/components/FrontPageDataProvider';
import type { FrontPageDataState } from 'bundles/front-page/components/FrontPageDataProvider';
import FrontPageGoogleSchemaMarkup from 'bundles/front-page/components/FrontPageGoogleSchemaMarkup';
import type { FrontPageContentProps as Props } from 'bundles/front-page/types';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import { CourseraMetatags } from 'bundles/seo';

type ConditionalFrontPageContentProps = FrontPageDataState & {
  isUsRegion: boolean;
  countryCode?: string;
};
export const ConditionalFrontPageCmsContent = ({
  pageContent,
  isUsRegion,
  ...otherProps
}: ConditionalFrontPageContentProps) => {
  return pageContent ? (
    <FrontPageCmsContent {...otherProps} key="lohp-cms-content" pageContent={pageContent} isUsRegion={isUsRegion} />
  ) : null;
};

const FrontPage = (props: Props) => {
  const { countryCode } = props;
  const isUsRegion = countryCode === 'us';

  return (
    <React.Fragment>
      <React.Fragment>
        <ConsumerLoggedOutHomePageHeader />
        <UniversalPageFeatures />
      </React.Fragment>
      <FrontPageDataProvider {...props}>
        {({ pageContent, ...otherProps }: FrontPageDataState) => (
          <ConditionalFrontPageCmsContent
            pageContent={pageContent}
            isUsRegion={isUsRegion}
            countryCode={countryCode}
            {...otherProps}
          />
        )}
      </FrontPageDataProvider>
      <PageFooter />
      <CourseraMetatags metaNameAndProperties={{ disableCourseraSuffix: true }} />

      <FrontPageGoogleSchemaMarkup />
    </React.Fragment>
  );
};

export default FrontPage;
